<generic-incident-modal [parent]="this">
    <ng-container header>
        <button class="icon--note btn--default" data-bs-toggle="modal" data-bs-target="#fraudNotesModal" *ngIf="null != incidentNumberId">Fraud Notes</button>
        <button class="icon--note btn--default" data-bs-toggle="modal" data-bs-target="#lawEnforcementFraudNotesModal" *ngIf="null != incidentNumberId">Law Enforcement Notes</button>
    </ng-container>
    <form [formGroup]="form">
        <h2>Fraudulent Document <button class="icon--add btn--default" type="button" (click)="addDocument()" *ngIf="false == data.isReadOnly"> Add Fraudulent Document</button></h2>
        <fieldset formArrayName="documents">
            <ng-container *ngFor="let d of documents.controls; let i = index">
                <div class="row" [formGroup]="d" *ngIf="false == d.get('deleted').value">
                    <div class="col-sm-6 mvd_form-group">
                        <label class="required" title="* Required">Fraud Document Type</label>
                        <select class="mvd_form-control" formControlName="documentTypeId">
                            <option [value]="null">- Select -</option>
                            <option *ngFor="let type of documentTypes" [value]="type.id">{{ type.displayValue }}</option>
                        </select>
                        <control-validation-messages control="documentTypeId"></control-validation-messages>
                    </div>
                    <div class="col-11 col-sm-5 mvd_form-group">
                        <label>Fraud Document Number</label>
                        <input type="text" class="mvd_form-control" formControlName="documentNumber" />
                    </div>
                    <div class="col-1 mvd_form-group">
                        <label>&nbsp;</label>
                        <a class="icon--delete" title="Delete" href="javascript:void(0)" (click)="deleteDocument(d)" *ngIf="(false == data.isReadOnly) && (null != d.get('documentId').value)"></a>
                    </div>
                </div>
            </ng-container>
        </fieldset>
        <h2>Incident Details</h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 mvd_form-group">
                    <label>Investigator Name</label>
                    <input class="mvd_form-control" formControlName="investigatorName" />
                </div>
                <div class="col-sm-6 mvd_form-group">
                    <label>Investigator Phone Number</label>
                    <input class="mvd_form-control" formControlName="investigatorPhoneNumber" />
                </div>
            </div>
        </fieldset>
    </form>
</generic-incident-modal>
<!-- Fraud Notes Modal -->
<div class="modal fade" id="fraudNotesModal" tabindex="-1" role="dialog" aria-labelledby="labelFraudNotes">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="labelFraudNotes">Fraud Notes</h4>
            </div>
            <div class="modal-body--scroll">
                <note [noteIdentificationValue]="data.incident.incidentNumberId" [noteIdentificationTypeId]="11" [countDisplayClass]="'note-count'" [isWip]="false" [isReadonly]="false == this.canEditNotes"></note>
            </div>
            <div class="modal-footer">
                <div class="btn--group">
                    <button class="btn--primary" type="button" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>
<!-- Law Enforcement Fraud Notes Modal -->
<div class="modal fade" id="lawEnforcementFraudNotesModal" tabindex="-1" role="dialog" aria-labelledby="lawEnforcementFraudNotes">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="lawEnforcementFraudNotes">Law Enforcement Fraud Notes</h4>
            </div>
            <div class="modal-body--scroll">
                <note [noteIdentificationValue]="data.incident.incidentNumberId" [noteIdentificationTypeId]="12" [countDisplayClass]="'note-count'" [isWip]="false" [isReadonly]="false == this.canEditNotes"></note>
            </div>
            <div class="modal-footer">
                <div class="btn--group">
                    <button class="btn--primary" type="button" data-bs-dismiss="modal">Close</button>
                </div>
            </div>
        </div>
    </div>
</div>